import capitalize from 'lodash/capitalize.js';
import kebabCase from 'lodash/kebabCase.js';

var Capitalize = function Capitalize(strLabel) {
  return strLabel && strLabel.charAt(0).toUpperCase() + strLabel.slice(1);
};

var UnderscoresToTitleCase = function UnderscoresToTitleCase(str) {
  if (!str) {
    return '';
  }

  var prepositions = ['a', 'an', 'the', 'and', 'but', 'or', 'on', 'to', 'is', 'for', 'in', 'with', 'of'];
  var regex = "/\b(".concat(prepositions.join('|'), "|([A-Z]w*))\b/");
  var htmlSplit = str.split('<').map(function (code) {
    return code.split('>');
  });
  var processedValue = htmlSplit.map(function (val) {
    if (val.length === 1) {
      return val[0].split('_').map(function (item, index) {
        if (index === 0 || !item.match(regex)) {
          return item[0].toUpperCase() + item.slice(1);
        } else if (item.match(regex)) {
          return item;
        }
      }).join(' ');
    } else {
      return "<".concat(val[0], ">").concat(val[1]);
    }
  });
  return processedValue.join('');
};

var Slugify = function Slugify(str) {
  str = str || '';
  str = kebabCase(str);
  str = str.replace(/[^a-zA-Z0-9\-\_]/g, '');
  return str.split('-').slice(0, 3).join('-');
};

var KebabCase = function KebabCase(str) {
  str = str || '';
  return kebabCase(str);
};

var AlphabetizeArrayOfObjects = function AlphabetizeArrayOfObjects(array, key) {
  var arrayCopy = Array.from(array);
  if (!Array.isArray(arrayCopy)) return [];
  return arrayCopy.sort(function (value1, value2) {
    if ((typeof value1[key] === 'string' || typeof value1[key] === 'number') && (typeof value2[key] === 'string' || typeof value2[key] === 'number')) {
      var textA = value1[key].toString().toUpperCase();
      var textB = value2[key].toString().toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    }
  });
};

var SplitFileName = function SplitFileName(fileName) {
  if (!fileName.includes('.')) {
    return {
      extension: null,
      name: fileName
    };
  }

  var splitName = fileName.split('.');
  var extension = ".".concat(splitName.pop());
  var name = splitName.join('.');
  return {
    extension: extension,
    name: name
  };
};

var ArrayToFormattedString = function ArrayToFormattedString(array) {
  var preposition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and'; // ignore null, undefined and empty values

  var curatedArr = array.filter(function (item) {
    return item;
  }); // join list by commas (oxford syntax) and preposition

  var listStart = curatedArr.slice(0, -1).join(', ');
  var listEnd = curatedArr.slice(-1);
  var conjunction = curatedArr.length <= 1 ? '' : curatedArr.length > 2 ? ", ".concat(preposition, " ") : " ".concat(preposition, " ");
  return [listStart, listEnd].join(conjunction);
};

var StartCase = function StartCase(string) {
  return string.replace(/\w+/g, capitalize);
};

var EnsurePluralization = function EnsurePluralization(str, count) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';

  if (str && count === 1 && str.slice(-1) === suffix) {
    return str.slice(0, -1);
  }

  return str && "".concat(str).concat(count !== 1 && str.slice(-1) !== suffix ? suffix : '');
};

export { AlphabetizeArrayOfObjects, ArrayToFormattedString, Capitalize, EnsurePluralization, KebabCase, Slugify, SplitFileName, StartCase, UnderscoresToTitleCase };